import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import createRootReducer from './root-reducer';

// create history
// export const history = createHistory();
// define on your own as per requirment
const store = createStore(createRootReducer(), composeWithDevTools(applyMiddleware(thunk)));

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export type StoreType = typeof store & { asyncReducers: AsyncReducers };

export default { ...store, asyncReducers: {} } as StoreType;
